export const StorageKeys = {
  token: "anfavea_token",
};
